const merge = require('lodash/merge');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');
const base64 = require('base-64');

function apiFactory({
  baseUrl,
  requestHandler
}) {
  const headers = {
    Accept: 'application/json'
  };

  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }

  return {
    getRecentSearchData(noOfRows, metaData) {
      const url = getUrl('get-recent-search');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST'
      };

      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode: parsedMetaData.portfolio.branchCode,
        lastNo: parseInt(noOfRows.slice(4))
      };

      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
      }));
    },
    getPortfolioOrPositionData(searchText, metaData) {
        const url = getUrl('search-position');
        const parsedMetaData = parseRequestMetaData(metaData);
        const reqOpts = {
          headers: merge(headers, parsedMetaData.headers),
          method: 'POST'
        };
  
        const body = {
          userId: parsedMetaData.qs.userId,
          branchCode: parsedMetaData.portfolio.branchCode,
          searchTerm: searchText.slice(4)
        };
  
        return requestHandler(merge(reqOpts, {
          url,
          body,
          json: true,
        }));
      },
      saveSearch(requestBody, metaData) {
        const url = getUrl('save-recent-search');
        const parsedMetaData = parseRequestMetaData(metaData);
        const parsedRequestBody = JSON.parse(base64.decode(requestBody))

        const reqOpts = {
          headers: merge(headers, parsedMetaData.headers),
          method: 'POST'
        };
  
        const body = {
          userId: parsedMetaData.qs.userId,
          branchCode: parsedMetaData.portfolio.branchCode,
          psSecNmb: parsedRequestBody.psSecNmb,
          psDesc: parsedRequestBody.psDesc,
          pfId: parsedRequestBody.pfId,
          pfPosId: parsedRequestBody.pfPosId || parsedRequestBody.psPosId,
          pfAstCls: parsedRequestBody.pfAstCls || parsedRequestBody.psAstCls,
        };
  
        return requestHandler(merge(reqOpts, {
          url,
          body,
          json: true,
        }));
      }
  };
}

module.exports = apiFactory;
